export default __webpack_public_path__ + "static/new8-01-190afab96b2e8cdcac74af55f49047d6.jpg";